import React, { useEffect, useState } from "react";
import { Col, Row, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import { MdOutlineReceiptLong } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { BsFillInfoCircleFill } from "react-icons/bs";
import {
  useRemoveFromFavouritesMutation,
  useUpdateMyDetailsMutation,
} from "../slices/customerSlice";
import { toast } from "react-toastify";
import { setCredentials } from "../slices/authSlice";

const OrderConfirmationScreen = ({ propOrder }) => {
  const location = useLocation();
  const { orderResponse: order } = location.state || {};
  const orderResponse = order || propOrder;
  // console.log("orderResonse");
  // console.log(orderResponse);
  const orderDetails = Array.isArray(orderResponse?.orderDetails)
    ? orderResponse.orderDetails
    : [];

  // console.log("orderDetails");
  // console.log(orderDetails);
  const { userInfo } = useSelector((state) => state.auth);
  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });
  const [orderStatus, setOrderStatus] = useState();
  const [favouriteFoods, setFavouriteFoods] = useState([]);

  const dispatch = useDispatch();

  const [addFavourites, { isLoading: addFavouritesLoading }] =
    useUpdateMyDetailsMutation();
  const [remFavourites, { isLoading: remFavouritesLoading }] =
    useRemoveFromFavouritesMutation();

  const toggleFavouriteFood = async (foodId) => {
    const isAlreadyFavourite = (userInfo?.favouriteFoods || []).includes(
      foodId
    );

    try {
      if (isAlreadyFavourite) {
        await remFavourites({
          favouriteFoodId: foodId,
          token: userInfo.token,
        }).unwrap();

        const updatedFavourites = userInfo.favouriteFoods.filter(
          (id) => id !== foodId
        );
        dispatch(
          setCredentials({
            ...userInfo,
            favouriteFoods: updatedFavourites,
          })
        );

        toast.success("Removed food from favourites!");
      } else {
        await addFavourites({
          favouriteFoodId: foodId,
          token: userInfo.token,
        }).unwrap();

        const updatedFavourites = [...(userInfo.favouriteFoods || []), foodId];
        dispatch(
          setCredentials({
            ...userInfo,
            favouriteFoods: updatedFavourites,
          })
        );

        toast.success("Added food to favourites!");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update food favourites");
    }
  };

  useEffect(() => {
    setOrderStatus(
      userInfo?.lastOrder?.orderId === orderResponse?._id
        ? userInfo?.lastOrder?.orderStatus
        : orderResponse?.orderStatus
    );
  }, [userInfo?.lastOrder, orderResponse]);

  return (
    <>
      <div
        className=" mt-3 text-center"
        style={{
          backgroundColor: "transparent",
          color: "black",
        }}
      >
        <Row>
          <h3 style={{ color: "black" }}>
            {" "}
            {orderResponse?.outletId?.outletName}
          </h3>
          <small className="header-subtitle">
            {orderResponse?.outletId?.outletAddress +
              " - " +
              orderResponse?.outletId?.outletPincode}
          </small>
          <span style={{ color: "grey" }}>
            Ph : {orderResponse?.outletId?.outletContact}
          </span>
          {orderResponse?.outletId?.outletGstNumber && (
            <small style={{ color: "grey" }}>
              GSTIN : {orderResponse?.outletId?.outletGstNumber}
            </small>
          )}
        </Row>
        <Row className="mt-1 text center">
          <h5 style={{ color: "green" }}>Order Placed Successfully</h5>
          {/* <h6 style={{ color: "black" }}>Order ID : </h6> */}
          {/* <small>Thank You for placing your order with us.</small> */}
        </Row>
        {!userInfo?.deliveryTo?.includes("undefined") && (
          <p>Seat - {userInfo?.deliveryTo}</p>
        )}
        Mobile : {orderResponse?.mobileNumber} <br />
        <span
          style={{
            color: orderStatus === "Ready" ? "green" : "grey",
            fontSize: orderStatus === "Ready" && "2rem",
          }}
        >
          Order Status : {orderStatus}
        </span>
        <br />
        <Row>
          <Col>Order ID : {orderResponse?.orderId}</Col>
          {/* <Col>Mobile : {orderResponse?.mobileNumber}</Col> */}
          <Col>Delivery OTP : {orderResponse?.deliveryOtp}</Col>
        </Row>
        <hr />
        <Row
          style={{
            // alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            width: "100%",
            margin: "1px",
            textAlign: "center",
            // border: "1px solid",
            // height: "50vh",
            // overflow: "scroll",
            borderRadius: "5px",
          }}
        >
          <Table
            style={{
              backgroundColor: "transparent",
              color: "black",
              border: "1px solid black",
            }}
          >
            <thead
              style={{
                backgroundColor: "transparent",
                color: "black",
                border: "1px solid black",
              }}
            >
              <tr></tr>
              <th style={{ backgroundColor: "inherit", color: "inherit" }}>
                Items
              </th>
              <th style={{ backgroundColor: "inherit", color: "inherit" }}>
                Price/Item
              </th>
              <th style={{ backgroundColor: "inherit", color: "inherit" }}>
                Tax
              </th>
              <th style={{ backgroundColor: "inherit", color: "inherit" }}>
                Qty
              </th>
              <th style={{ backgroundColor: "inherit", color: "inherit" }}>
                Amount
              </th>
            </thead>
            <tbody style={{ backgroundColor: "transparent", color: "black" }}>
              {orderDetails?.map((it) => {
                // console.log("Item in orderDetails", it);
                return (
                  <tr key={it.itemId}>
                    <td>
                      {it.itemName}{" "}
                      {it.sizeName !== "Single Size" && (
                        <small style={{ fontStyle: "italic" }}>
                          {" "}
                          {it.sizeName}
                        </small>
                      )}
                      <span
                        onClick={() => toggleFavouriteFood?.(it.foodItemId)}
                        style={{
                          cursor: "pointer",
                          color: (userInfo?.favouriteFoods || []).includes(
                            it.foodItemId
                          )
                            ? "red"
                            : "gray",
                          marginLeft: "6px",
                          fontSize: "1.2rem",
                        }}
                      >
                        {(userInfo?.favouriteFoods || []).includes(
                          it.foodItemId
                        )
                          ? "♥"
                          : "♡"}
                      </span>
                    </td>

                    <td>
                      {" "}
                      <span style={{ textDecoration: "line-through" }}>
                        {(it.discountPercent > 0 || it.discountAmount > 0) &&
                          it.sellingPrice}
                      </span>{" "}
                      {it.sellingPriceAfterOffers.toFixed(2)}
                    </td>

                    <td>
                      {it.gstTax > 0 && (
                        <>
                          {it.gstAmount.toFixed(2)}
                          <OverlayTrigger
                            trigger="click"
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${it.itemId}`}>
                                GST: {it.gstTax}%
                              </Tooltip>
                            }
                            rootClose
                          >
                            <span
                              style={{
                                cursor: "pointer",
                                marginLeft: "5px",
                              }}
                            >
                              <BsFillInfoCircleFill />
                            </span>
                          </OverlayTrigger>
                        </>
                      )}
                    </td>
                    <td>{it.itemQuantity}</td>
                    <td>
                      {(
                        it.itemQuantity *
                        (it.sellingPriceAfterOffers + it.gstAmount)
                      ).toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          {userInfo?.outletsDetails[0]?.companyId?.separatePlaformFee && (
            <Row>
              <Col>
                Platform Fee{" "}
                {userInfo?.outletsDetails[0].companyId.platformFee || 3}% - Rs.{" "}
                {orderResponse?.platformFee?.toFixed(2) || "0.00"}
              </Col>
            </Row>
          )}
        </Row>
        <hr />
        <Row>
          <Col>
            Total Amount Paid <br />
            <br />
            <h6 style={{ color: "black" }}>
              ₹{" "}
              {order?.grossTotal ? order.grossTotal : orderResponse.grossTotal}{" "}
              |{" "}
              {orderDetails?.reduce((total, it) => total + it.itemQuantity, 0)}{" "}
              Items
            </h6>
          </Col>
        </Row>
        <br />
        {orderResponse?.createdAt ? (
          <>
            Date :{" "}
            {new Date(
              new Date(orderResponse.createdAt).getTime() + 5 * 60 * 60 * 1000
            )
              .toISOString()
              .slice(0, 10)}{" "}
            {new Date(
              new Date(orderResponse.createdAt).getTime() + 5 * 60 * 60 * 1000
            )
              .toISOString()
              .slice(11, 16)}
          </>
        ) : (
          "Date not available"
        )}
        <br />
        <br />
        <br />
        <br />
        <br />
        <small style={{ marginTop: "50px" }}>
          * as part of our go-green policy, We are not providing paper receipt.
          You can treat this as bill copy *
        </small>
      </div>
    </>
  );
};

export default OrderConfirmationScreen;
